/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_Modal_TitleInputs */

const en_comment_modal_title = /** @type {(inputs: Comment_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a comment`)
};

const ja_comment_modal_title = /** @type {(inputs: Comment_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを追加`)
};

const fr_comment_modal_title = /** @type {(inputs: Comment_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un commentaire`)
};

const de_comment_modal_title = /** @type {(inputs: Comment_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a comment" |
*
* @param {Comment_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_modal_title = /** @type {((inputs?: Comment_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_modal_title(inputs)
	if (locale === "ja") return ja_comment_modal_title(inputs)
	if (locale === "fr") return fr_comment_modal_title(inputs)
	return de_comment_modal_title(inputs)
});